module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', [_vm._v("きらり薬局について")]), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo-footer.png")
    }
  })]), _c('p', [_vm._v("福岡県内に13店舗、千葉県に1店舗を展開している保険調剤薬局です。")]), _c('p', [_vm._v("医師の指示に基づき、通院困難なご利用者様の薬剤師が直接ご自宅に伺います。")])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_vm._v("24時間365日対応で、医師、看護師、ケアマネージャー、介護スタッフの方々と連携・協力して、ご利用者様が安心して薬を飲み続けられるようにサポート致します。")]), _c('p', [_vm._v("8年間で数万件の在宅実績があり、看取り・ターミナルケアは年間数十件行っております。")]), _c('p', [_vm._v("難病の方、IVH（中心静脈栄養）にも対応してきました。")]), _c('p', [_vm._v("お薬についてお困りのことがありましたら、いつでもご相談ください。")])])])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', [_vm._v("FIND US ON FACEBOOK")]), _c('a', {
    staticClass: "facebook-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/%E3%81%8D%E3%82%89%E3%82%8A%E8%96%AC%E5%B1%80%E6%AD%A3%E7%A4%BE%E5%93%A1%E3%83%91%E3%83%BC%E3%83%88%E3%82%82%E9%9A%8F%E6%99%82%E5%8B%9F%E9%9B%86%E4%B8%AD%E6%9C%AA%E7%B5%8C%E9%A8%93%E6%96%B0%E5%8D%92%E3%82%82%E4%B8%81%E5%AF%A7%E3%81%AB%E6%95%99%E3%81%88%E3%81%BE%E3%81%99%E4%BC%81%E6%A5%AD%E5%86%85%E8%A8%97%E5%85%90%E6%89%80%E7%97%85%E9%99%A2%E3%81%B8%E3%81%AE%E7%A0%94%E4%BF%AE%E5%88%B6%E5%BA%A6%E6%9C%89%E3%82%8A%E8%A9%B3%E3%81%97%E3%81%8F%E3%81%AF%E3%81%8D%E3%82%89%E3%82%8A%E8%96%AC%E5%B1%80%E3%81%A7%E6%A4%9C%E7%B4%A2-174204956011899/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official"
  })]), _c('p', [_vm._v("きらり薬局（正社員、パートも随時募集中。未経験、新卒も丁寧に教えます。）企業内託児所、病院への研修制度有り。詳しくは「きらり薬局」で検索。")])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', [_vm._v("お問い合わせ")]), _c('p', [_vm._v("施設運営者様、医療機関様、介護事業者様との連携をサポート致します。医療・介護のご相談等お気軽にご連絡ください。")]), _c('div', {
    staticClass: "margin-top"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _c('span', [_vm._v("  Hyuga Pharmacy株式会社　春日事務所（福岡エリア）")])]), _c('p', [_c('i', {
    staticClass: "fa fa-phone"
  }), _c('span', [_vm._v("  092-558-2120")])])]), _c('div', {
    staticClass: "margin-top"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _c('span', [_vm._v("  きらり薬局　鎌取店（千葉エリア）")])]), _c('p', [_c('i', {
    staticClass: "fa fa-phone"
  }), _c('span', [_vm._v("  043-309-7718")])])])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('strong', [_vm._v("「処方箋を元気にかえる！」をモットーに地域に根ざした「かかりつけ薬局」として皆様に貢献できる薬局を目指し続けます。")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', {
    staticClass: "copy-right"
  }, [_vm._v("Copyright 2015 Hyuga Pharmacy Corporation All Rights Reserved.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7dd22f68!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app-footer.pug
// module id = 402
// module chunks = 1